import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { EnvironmentRuntimeProvider } from './core/providers/environment-runtime.provider';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from "@angular/core";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from "@fuse/components";
import { FuseModule } from "@fuse/fuse.module";
import { FuseSharedModule } from "@fuse/shared.module";

import { fuseConfig } from "app/fuse-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { SampleModule } from "app/main/sample/sample.module";
import { appRoutes } from "./app.routes";
import { CoreModule } from "./core/core.module";
import { RequestInterceptor } from "./core/service/interceptors/request-interceptor";

import { registerLocaleData } from "@angular/common";
import localeExtraPT from "@angular/common/locales/extra/pt";
import localePT from "@angular/common/locales/pt";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { MonacoEditorModule } from "ngx-monaco-editor";
import { SubscriptionService } from "./core/service/subscription.service";
import { GenericNotificationModule } from "./shared/components/generic-notification/generic-notification.module";

registerLocaleData(localePT, "pt", localeExtraPT);

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        LayoutModule,
        SampleModule,
        CoreModule,
        MonacoEditorModule.forRoot(),
        GenericNotificationModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (envProvider: EnvironmentRuntimeProvider) => () => envProvider.initialize(),
            deps: [EnvironmentRuntimeProvider],
            multi: true
        },
        { provide: LOCALE_ID, useValue: "pt" },
        { provide: MAT_DATE_LOCALE, useValue: "pt-BR" },
        {
            provide: APP_INITIALIZER,
            // Provide the APP_INITIALIZER, wait until the theming configuration is fetched and set up correctly
            useFactory: (subscriptionService: SubscriptionService) => () => subscriptionService.initialize(),
            deps: [SubscriptionService],
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
